// Signature Lucrative Laptop brush devices, drawn as inline SVG so they stay
// crisp, transparent and tintable via currentColor.

export function BrushUnderline({ className = "", style }) {
  return (
    <svg className={className} style={style} viewBox="0 0 300 26" preserveAspectRatio="none" fill="none" aria-hidden="true">
      <path d="M2 15 C 45 6 85 20 135 12 C 190 4 240 19 298 9 L 297 17 C 240 27 188 15 134 21 C 84 27 44 16 3 23 Z" fill="currentColor" />
      <circle cx="292" cy="6" r="2.1" fill="currentColor" />
      <circle cx="8" cy="22" r="1.6" fill="currentColor" />
      <rect x="150" y="23" width="10" height="2.2" fill="currentColor" opacity="0.7" />
    </svg>
  );
}

export function BrushHighlight({ className = "", style }) {
  return (
    <svg className={className} style={style} viewBox="0 0 300 120" preserveAspectRatio="none" fill="none" aria-hidden="true">
      <path d="M6 30 C 60 10 140 8 210 18 C 260 25 292 20 296 40 C 300 62 280 92 220 100 C 150 110 70 108 20 96 C 0 90 2 50 6 30 Z" fill="currentColor" />
    </svg>
  );
}

// A word wrapped with the green brush underline sweeping beneath it.
export function BrushWord({ children, className = "", color = "text-brand" }) {
  return (
    <span className={`relative inline-block ${className}`}>
      <span className="relative z-10">{children}</span>
      <BrushUnderline className={`absolute left-0 -bottom-[0.12em] w-full h-[0.28em] ${color}`} />
    </span>
  );
}

export default BrushUnderline;
